module.exports = {
  id: 24,
  name: 'Push-ups',
  categories: ['strength', 'arms', 'core'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Strength',
  points: 15,
  instructions:
    'Push-ups make your arms strong! Get in a push-up position, lower your body down, then push back up. If regular push-ups are too hard, put your knees on the ground and do knee push-ups!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to get strong arms? Let us build incredible strength!',
    },
    {
      time: 3,
      text: 'Get in push-up position, hands shoulder-width apart!',
    },
    {
      time: 6,
      text: 'Keep your body straight like a board, engage your core!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Lower your body down with control!',
    },
    // SET 1 - 10 reps
    {
      time: 12,
      text: 'Perfect push-up position! Keep your body straight!',
    },
    {
      time: 15,
      text: 'Number 1! Lower your body down with control, keep your core tight!',
    },
    {
      time: 18,
      text: 'Push back up with your arms and chest, stay strong!',
    },
    {
      time: 21,
      text: 'Number 2! Lower your body down with control, you are doing great!',
    },
    {
      time: 24,
      text: 'Push back up with your arms and chest, keep going!',
    },
    {
      time: 27,
      text: 'Number 3! Lower your body down with control, stay focused!',
    },
    {
      time: 30,
      text: 'Push back up with your arms and chest, you are strong!',
    },
    {
      time: 33,
      text: 'Number 4! Lower your body down with control, keep your core engaged!',
    },
    {
      time: 36,
      text: 'Push back up with your arms and chest, you are doing amazing!',
    },
    {
      time: 39,
      text: 'Number 5! Lower your body down with control, stay strong!',
    },
    {
      time: 42,
      text: 'Push back up with your arms and chest, keep going!',
    },
    {
      time: 45,
      text: 'Number 6! Lower your body down with control, you are doing great!',
    },
    {
      time: 48,
      text: 'Push back up with your arms and chest, stay focused!',
    },
    {
      time: 51,
      text: 'Number 7! Lower your body down with control, keep your core tight!',
    },
    {
      time: 54,
      text: 'Push back up with your arms and chest, you are strong!',
    },
    {
      time: 57,
      text: 'Number 8! Lower your body down with control, you are doing amazing!',
    },
    {
      time: 60,
      text: 'Push back up with your arms and chest, keep going!',
    },
    {
      time: 63,
      text: 'Number 9! Lower your body down with control, stay strong!',
    },
    {
      time: 66,
      text: 'Push back up with your arms and chest, you are doing great!',
    },
    {
      time: 69,
      text: 'Number 10! Lower your body down with control, almost there!',
    },
    {
      time: 72,
      text: 'Push back up with your arms and chest, incredible work!',
    },
    {
      time: 75,
      text: 'Great job! Take a deep breath and shake out your arms.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 78,
      text: 'Take a deep breath in and out, you are building incredible arm strength!',
    },
    {
      time: 81,
      text: 'Shake out your arms and chest, get ready for round two!',
    },
    {
      time: 84,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 87,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 2 - 10 reps
    {
      time: 90,
      text: 'Get in push-up position, hands shoulder-width apart!',
    },
    {
      time: 93,
      text: 'Keep your body straight like a board, engage your core!',
    },
    {
      time: 96,
      text: 'Perfect push-up position! Lower your body down with control!',
    },
    {
      time: 99,
      text: 'Number 1! Lower your body down with control, keep your core tight!',
    },
    {
      time: 102,
      text: 'Push back up with your arms and chest, stay strong!',
    },
    {
      time: 105,
      text: 'Number 2! Lower your body down with control, you are doing great!',
    },
    {
      time: 108,
      text: 'Push back up with your arms and chest, keep going!',
    },
    {
      time: 111,
      text: 'Number 3! Lower your body down with control, stay focused!',
    },
    {
      time: 114,
      text: 'Push back up with your arms and chest, you are strong!',
    },
    {
      time: 117,
      text: 'Number 4! Lower your body down with control, keep your core engaged!',
    },
    {
      time: 120,
      text: 'Push back up with your arms and chest, you are doing amazing!',
    },
    {
      time: 123,
      text: 'Number 5! Lower your body down with control, stay strong!',
    },
    {
      time: 126,
      text: 'Push back up with your arms and chest, keep going!',
    },
    {
      time: 129,
      text: 'Number 6! Lower your body down with control, you are doing great!',
    },
    {
      time: 132,
      text: 'Push back up with your arms and chest, stay focused!',
    },
    {
      time: 135,
      text: 'Number 7! Lower your body down with control, keep your core tight!',
    },
    {
      time: 138,
      text: 'Push back up with your arms and chest, you are strong!',
    },
    {
      time: 141,
      text: 'Number 8! Lower your body down with control, you are doing amazing!',
    },
    {
      time: 144,
      text: 'Push back up with your arms and chest, keep going!',
    },
    {
      time: 147,
      text: 'Number 9! Lower your body down with control, stay strong!',
    },
    {
      time: 150,
      text: 'Push back up with your arms and chest, you are doing great!',
    },
    {
      time: 153,
      text: 'Number 10! Lower your body down with control, almost there!',
    },
    {
      time: 156,
      text: 'Push back up with your arms and chest, incredible work!',
    },
    {
      time: 159,
      text: 'Great job! Take a deep breath and shake out your arms.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 162,
      text: 'Take a deep breath in and out, you are building incredible arm strength!',
    },
    {
      time: 165,
      text: 'Shake out your arms and chest, get ready for the final round!',
    },
    {
      time: 168,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 171,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 3 - 10 reps
    {
      time: 174,
      text: 'Get in push-up position, hands shoulder-width apart!',
    },
    {
      time: 177,
      text: 'Keep your body straight like a board, engage your core!',
    },
    {
      time: 180,
      text: 'Perfect push-up position! Lower your body down with control!',
    },
    {
      time: 183,
      text: 'Number 1! Lower your body down with control, keep your core tight!',
    },
    {
      time: 186,
      text: 'Push back up with your arms and chest, stay strong!',
    },
    {
      time: 189,
      text: 'Number 2! Lower your body down with control, you are doing great!',
    },
    {
      time: 192,
      text: 'Push back up with your arms and chest, keep going!',
    },
    {
      time: 195,
      text: 'Number 3! Lower your body down with control, stay focused!',
    },
    {
      time: 198,
      text: 'Push back up with your arms and chest, you are strong!',
    },
    {
      time: 201,
      text: 'Number 4! Lower your body down with control, keep your core engaged!',
    },
    {
      time: 204,
      text: 'Push back up with your arms and chest, you are doing amazing!',
    },
    {
      time: 207,
      text: 'Number 5! Lower your body down with control, stay strong!',
    },
    {
      time: 210,
      text: 'Push back up with your arms and chest, keep going!',
    },
    {
      time: 213,
      text: 'Number 6! Lower your body down with control, you are doing great!',
    },
    {
      time: 216,
      text: 'Push back up with your arms and chest, stay focused!',
    },
    {
      time: 219,
      text: 'Number 7! Lower your body down with control, keep your core tight!',
    },
    {
      time: 222,
      text: 'Push back up with your arms and chest, you are strong!',
    },
    {
      time: 225,
      text: 'Number 8! Lower your body down with control, you are doing amazing!',
    },
    {
      time: 228,
      text: 'Push back up with your arms and chest, keep going!',
    },
    {
      time: 231,
      text: 'Number 9! Lower your body down with control, stay strong!',
    },
    {
      time: 234,
      text: 'Push back up with your arms and chest, you are doing great!',
    },
    {
      time: 237,
      text: 'Number 10! Lower your body down with control, almost there!',
    },
    {
      time: 240,
      text: 'Push back up with your arms and chest, incredible work!',
    },
    {
      time: 243,
      text: 'Incredible work! You are done! You just completed all three sets!',
    },
    // COMPLETION
    {
      time: 246,
      text: 'Amazing work! You did 30 push-ups and built incredible arm strength!',
    },
    {
      time: 249,
      text: 'Your arms are getting super strong! You are a strength champion!',
    },
    {
      time: 252,
      text: 'Great job, strength champion! You are building incredible power!',
    },
  ],
};
